import Api from '@/services/Api'

export default {

  DownloadCart(config) {
    return Api().post('/cart/downloads', config);
  },
  GetMediaSizes(config) {
    return Api().post('/cart/mediasize/', config);
  },
  GetCartDownloadStatus(id) {
    return Api().get('/cart/downloads/' + id + '/status');
  },
  GetOngoingDownloads() {
    return Api().get('/cart/downloads/ongoing');
  },
  ShareCart(cart) {
    return Api().post('/sharedcarts', cart);
  },
  SaveCartItems(cart) {
    return Api().put('/sharedcarts/' + cart.id + '/items', cart.cartItems);
  },
  EditCart(cart) {
    return Api().put('/sharedcarts', cart);
  },
  GetCart(id){
    return Api().get('/sharedcarts/' + id);
  },
  DeleteCart(cartId){
    return Api().delete('/sharedcarts/' + cartId);
  }
}
